// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3fyxv","unreadBadge":"styles_unreadBadge__1cGqd","modalContent":"styles_modalContent__3QNm7","modal":"styles_modal__3NHcY"};